import { DASHBOARD_DENSITY } from '@/features/dashboard/types/dashboard-density-enums';

import { BREAKPOINT_TIER } from '../types/grid-enums';

export const BREAKPOINTS: Record<BREAKPOINT_TIER, number> = {
  [BREAKPOINT_TIER.DESKTOP]: 900,
  [BREAKPOINT_TIER.TABLET]: 480,
  [BREAKPOINT_TIER.MOBILE]: 0,
};

export const COLS_BY_TIER: Record<BREAKPOINT_TIER, number> = {
  [BREAKPOINT_TIER.DESKTOP]: 12,
  [BREAKPOINT_TIER.TABLET]: 6,
  [BREAKPOINT_TIER.MOBILE]: 6,
};

export const VERTICAL_GAP_BY_DENSITY: Record<DASHBOARD_DENSITY, number> = {
  [DASHBOARD_DENSITY.COMPACT]: 14,
  [DASHBOARD_DENSITY.NORMAL]: 16,
};

export const MOBILE_VERTICAL_GAP_BY_DENSITY: Record<DASHBOARD_DENSITY, number> = {
  [DASHBOARD_DENSITY.COMPACT]: 12,
  [DASHBOARD_DENSITY.NORMAL]: 16,
};

export const DEFAULT_GRID_CONFIG = {
  maxWidth: 1200,
} as const;
